import React from 'react'
import {
  Signin,
  LogView,
  UserList,
  Dashboard,
  Shipments,
  EventList,
  Inventory,
  OrderList,
  CreateUser,
  CreatePipe,
  CreateMine,
  CreateCost,
  CreateEvent,
  UserDetails,
  CreateBatch,
  CreateOrder,
  MineDetails,
  PipeDetails,
  CostDetails,
  CreateShape,
  ReportsList,
  OrderDetails,
  BatchDetails,
  CreateCountry,
  ShapeDetails,
  BuyerSettings,
  CountryDetails,
  RoughStoneList,
  CreateShipment,
  AssortmentList,
  SellerSettings,
  CreateCutGrade,
  UploadBaseline,
  CreateTingeMap,
  ShipmentDetails,
  UploadCutGrades,
  CutGradeDetails,
  TingeMapDetails,
  BaselineDetails,
  OrganizationList,
  CreateAssortment,
  ProvenanceSearch,
  CreateRoughStone,
  RoughStoneDetails,
  AssortmentDetails,
  TransactionDetails,
  NotificationList,
  CreateOrganization,
  OrganizationDetails,
  SaveMultipleRoughs,
  CreateComputedBaseline,
  PlanningList,
  CreateSpsRequests,
  PlanningDetails,
  SalesList,
  CreateSale,
  SaleDetails,
  QCStonesList,
  EventDetails,
  AppNotificationDetails,
  EmailNotificationDetails,
  NotificationTemplateList,
  NotificationTemplateDetails,
  CreateNotificationTemplate,
  CreateNotification,
  RoleAndPermissionList,
  ShapeGroupList,
  ShapeGroupDetails,
  Settings,
  PaymentDetails,
  InvoiceDetails,
  Finance,
  RoleList
} from '../components/pages/pages'
import * as actions from '@actions'

const routes = {
  // External routes are any route which is not
  // accessible via navigation. E.g. Signin
  external: [
    {
      path: '/signin',
      label: 'Sign In',
      icon: null,
      exact: false,
      component: Signin
    },
    {
      path: '/assortments/create',
      label: 'Create Assortment',
      icon: null,
      exact: false,
      component: CreateAssortment
    },
    {
      path: '/assortments/:assortmentId/roughstones/create',
      label: 'Create Rough Stone',
      icon: null,
      exact: false,
      component: CreateRoughStone
    },
    {
      path: '/assortments/:assortmentId/roughstones/upload',
      label: 'Upload Stones',
      icon: null,
      exact: false,
      component: SaveMultipleRoughs
    },
    {
      path: '/qc/roughstones/upload',
      label: 'Excel Update',
      icon: null,
      exact: false,
      component: SaveMultipleRoughs
    },
    {
      path: '/roughstones/upload',
      label: 'Excel Update',
      icon: null,
      exact: false,
      component: SaveMultipleRoughs
    },
    {
      path: '/roughstones/:roughStoneId/',
      label: 'Rough Stone Details',
      icon: null,
      exact: false,
      component: RoughStoneDetails
    },
    {
      path: '/assortments/:assortmentId',
      label: 'Assortment Details',
      icon: null,
      exact: false,
      component: AssortmentDetails
    },
    {
      path: '/seller-settings/countries/create',
      label: 'Create Country',
      icon: null,
      exact: false,
      component: CreateCountry
    },
    {
      path: '/seller-settings/mines/create',
      label: 'Create Mine',
      icon: null,
      exact: false,
      component: CreateMine
    },
    {
      path: 'seller-settings/pipes/create',
      label: 'Create Pipe',
      icon: null,
      exact: false,
      component: CreatePipe
    },
    {
      path: '/seller-settings/batches/create',
      label: 'Create Batch',
      icon: null,
      exact: false,
      component: CreateBatch
    },
    {
      path: '/events/create',
      label: 'Create Event',
      icon: null,
      exact: false,
      component: CreateEvent
    },
    {
      path: '/events/:eventId',
      label: 'Event Details',
      icon: null,
      exact: false,
      component: EventDetails
    },
    {
      path: '/seller-settings/countries/:countryId',
      label: 'Country Details',
      icon: null,
      exact: false,
      component: CountryDetails
    },
    {
      path: '/seller-settings/mines/:mineId',
      label: 'Mine Details',
      icon: null,
      exact: false,
      component: MineDetails
    },
    {
      path: '/seller-settings/pipes/:pipeId',
      label: 'Pipe Details',
      icon: null,
      exact: false,
      component: PipeDetails
    },
    {
      path: '/seller-settings/batches/:batchId',
      label: 'Batch Details',
      icon: null,
      exact: false,
      component: BatchDetails
    },
    {
      path: '/dashboard/transactions/:transactionId',
      label: 'Transaction Details',
      icon: null,
      exact: false,
      component: TransactionDetails
    },

    // Users routes
    {
      path: '/users/create',
      label: 'Create User',
      iconName: 'createUser',
      exact: false,
      component: CreateUser
    },
    {
      path: '/users/:userId',
      label: 'User Details',
      icon: null,
      exact: false,
      component: UserDetails
    },
    // Organization routes
    {
      path: '/organizations/create',
      label: 'Create Organization',
      icon: null,
      exact: false,
      component: CreateOrganization
    },
    {
      path: '/organizations/:orgId',
      label: 'Organization Details',
      icon: null,
      exact: false,
      component: OrganizationDetails
    },
    {
      path: '/orders/create',
      label: 'Create Order',
      icon: null,
      exact: true,
      component: CreateOrder
    },
    {
      path: '/orders/:orderId',
      label: 'Order Details',
      icon: null,
      exact: false,
      component: OrderDetails
    },

    // Buyer routes
    {
      path: '/buyer-settings/shapes/create',
      label: 'Create Shape',
      icon: null,
      exact: true,
      component: CreateShape
    },
    {
      path: '/buyer-settings/cutgrades/create',
      label: 'Create Cut Grade',
      icon: null,
      exact: true,
      component: CreateCutGrade
    },
    {
      path: '/buyer-settings/cutgrades/upload',
      label: 'Upload Sarine File',
      icon: null,
      exact: true,
      component: UploadCutGrades
    },
    {
      path: '/buyer-settings/baselines/upload',
      label: 'Upload Baseline',
      icon: null,
      exact: true,
      component: UploadBaseline
    },
    {
      path: '/buyer-settings/baselines/create',
      label: 'Create Baseline',
      icon: null,
      exact: true,
      component: CreateComputedBaseline
    },
    {
      path: '/buyer-settings/baselines/:baselineId',
      label: 'Baseline Details',
      icon: null,
      exact: true,
      component: BaselineDetails
    },
    {
      path: '/buyer-settings/tingemaps/create',
      label: 'Create Tinge Map',
      icon: null,
      exact: true,
      component: CreateTingeMap
    },
    {
      path: '/buyer-settings/mfgcosts/create',
      label: 'Create Manufacturing Cost',
      icon: null,
      exact: true,
      component: () => <CreateCost costType='mfg' />
    },
    {
      path: '/buyer-settings/certcosts/create',
      label: 'Create Certificate Cost',
      icon: null,
      exact: true,
      component: () => <CreateCost costType='cert' />
    },
    {
      path: '/buyer-settings/shapes/:shapeId/',
      label: 'Shape Details',
      icon: null,
      exact: false,
      component: ShapeDetails
    },
    {
      path: '/buyer-settings/cutgrades/:cutGradeId/',
      label: 'Cut Grade Details',
      icon: null,
      exact: true,
      component: CutGradeDetails
    },
    {
      path: '/buyer-settings/tingemaps/:tingeMapId/',
      label: 'Tinge Map Details',
      icon: null,
      exact: true,
      component: TingeMapDetails
    },
    {
      path: '/notifications/templates/',
      label: 'Notification Templates',
      icon: null,
      exact: true,
      component: NotificationTemplateList
    },
    {
      path: '/buyer-settings/mfgcosts/:costId/',
      label: 'Manufacturing Cost Details',
      icon: null,
      exact: true,
      component: (props) => <CostDetails costType='mfg' {...props} />
    },
    {
      path: '/buyer-settings/certcosts/:costId/',
      label: 'Certificate Cost Details',
      icon: null,
      exact: true,
      component: (props) => <CostDetails costType='cert' {...props} />
    },
    {
      path: '/notifications/create',
      label: 'Create Notification',
      icon: null,
      exact: true,
      component: CreateNotification
    },
    {
      path: '/notifications/templates/create',
      label: 'Create Notification Template',
      icon: null,
      exact: true,
      component: CreateNotificationTemplate
    },
    {
      path: '/notifications/app/:notificationId',
      label: 'App Notification Details',
      icon: null,
      exact: false,
      component: AppNotificationDetails
    },
    {
      path: '/notifications/email/:emailId',
      label: 'Email Notification Details',
      icon: null,
      exact: false,
      component: EmailNotificationDetails
    },
    {
      path: '/notifications/templates/:templateId',
      label: 'Notification Template Details',
      icon: null,
      exact: false,
      component: NotificationTemplateDetails
    },
    // SPS routes
    {
      path: '/planning/create',
      label: 'Create SPS Requests',
      icon: null,
      exact: true,
      component: CreateSpsRequests
    },
    {
      path: '/planning/sales',
      label: 'Sales',
      icon: null,
      exact: true,
      component: SalesList
    },
    {
      path: '/planning/sales/create',
      label: 'Create Sale',
      icon: null,
      exact: true,
      component: CreateSale
    },
    {
      path: '/planning/sales/:saleId/',
      label: 'Sale Details',
      icon: null,
      exact: true,
      component: SaleDetails
    },
    {
      path: '/planning/:requestId/',
      label: 'Planning Details',
      icon: null,
      exact: true,
      component: PlanningDetails
    },
    {
      path: '/qc/planning/:requestId/',
      label: 'Planning Details',
      icon: null,
      exact: true,
      component: PlanningDetails
    },
    {
      path: '/shipments/create',
      label: 'Create Shipment ',
      icon: null,
      exact: true,
      component: CreateShipment,
      displayFor: [actions.logisticsActions.getShipmentList]
    },
    {
      path: '/shipments/:shipmentId/',
      label: 'Shipment Details',
      icon: null,
      exact: true,
      component: ShipmentDetails
    },
    {
      path: '/finance/invoices/:invoiceId/',
      label: 'Invoice Details',
      icon: null,
      exact: true,
      component: InvoiceDetails,
      displayFor: [actions.logisticsActions.getInvoices]
    },
    {
      path: '/finance/payments/:paymentId/',
      label: 'Payment Details',
      icon: null,
      exact: true,
      component: PaymentDetails,
      displayFor: [actions.logisticsActions.getPayments]
    },
    {
      path: '/shapegroups/:shapeGroupId',
      label: 'Shape Groups Details',
      icon: null,
      exact: true,
      component: ShapeGroupDetails,
      displayForAdmin: [actions.shapeGroupActions.getShapeGroupsList]
    },
    {
      path: '/roles-and-permissions/roles',
      label: 'Roles',
      icon: null,
      exact: false,
      component: RoleList,
      displayForAdmin: [actions.roleAndPermissionAction.getRoles]
    }
  ],
  navigation: {
    overview: [
      {
        path: '/dashboard',
        label: 'Dashboard',
        iconName: 'dashboard',
        exact: false,
        component: Dashboard,
        displayFor: [actions.saleActions.getSales]
      },
      {
        path: '/inventory',
        label: 'Inventory',
        iconName: 'inventory',
        exact: false,
        component: Inventory,
        displayFor: [actions.roughStoneActions.getAvailability]
      },

      {
        path: '/provenance-search',
        label: 'Provenance',
        iconName: 'provenance',
        exact: false,
        component: ProvenanceSearch,
        displayFor: [actions.roughStoneActions.getRoughStoneForBlockchain]
      },
      {
        path: '/reports',
        label: 'Reports',
        iconName: 'report',
        exact: false,
        component: ReportsList,
        displayFor: [actions.reportActions.listReports, actions.reportActions.listUserReports]
      }
    ],
    main: [
      {
        path: '/seller-settings',
        label: 'Seller Settings',
        iconName: 'buyerSettings',
        iconClassName: 'icon--flip-horizontal',
        exact: false,
        component: SellerSettings,
        displayFor: [actions.provenanceActions.getPipes, actions.provenanceActions.getBatches]
      },
      {
        path: '/assortments',
        label: 'Assortments',
        iconName: 'assortment',
        exact: false,
        component: AssortmentList,
        displayFor: [actions.assortmentActions.getAssortmentList]
      },
      {
        path: '/roughstones',
        label: 'Rough Stones',
        iconName: 'roughStone',
        exact: false,
        component: RoughStoneList,
        displayFor: [actions.roughStoneActions.getRoughStoneList]
      },
      {
        path: '/buyer-settings',
        label: 'Buyer Settings',
        iconName: 'buyerSettings',
        exact: true,
        component: BuyerSettings,
        displayFor: [actions.cutGradeActions.getShapeList, actions.cutGradeActions.getCutGradeList, actions.baselineActions.getBaselines, actions.costActions.getMfgCostList, actions.costActions.getCertCostList, actions.tingeMapActions.getTingeMapList]
      },
      {
        path: '/orders',
        label: 'Orders',
        iconName: 'orders',
        exact: false,
        component: OrderList,
        displayFor: [actions.orderActions.getOrderList]
      },
      {
        path: '/qc',
        label: 'QC',
        iconName: 'clipboardCheck',
        exact: false,
        component: QCStonesList,
        displayFor: [actions.planningActions.getQcPlannedStones]
      },
      {
        path: '/planning',
        label: 'Planning',
        iconName: 'planning',
        exact: false,
        component: PlanningList,
        displayForAdmin: [actions.planningActions.getPlannedStones]
      },
      {
        path: '/shipments',
        label: 'Shipments',
        iconName: 'shipments',
        exact: true,
        component: Shipments,
        displayFor: [actions.logisticsActions.getShipments]
      },
      {
        path: '/finance',
        label: 'Finance',
        iconName: 'dollars',
        exact: true,
        component: Finance,
        displayFor: [actions.logisticsActions.getInvoices]
      }
    ],
    admin: [
      {
        path: '/organizations',
        label: 'Organizations',
        iconName: 'organizations',
        exact: false,
        component: OrganizationList,
        displayForAdmin: [actions.organizationActions.getOrganizationList]
      },
      {
        path: '/users',
        label: 'Users',
        iconName: 'users',
        exact: false,
        component: UserList,
        displayForAdmin: [actions.userActions.getUsersList]
      },
      {
        path: '/events',
        label: 'Events',
        iconName: 'menuCalendar',
        exact: false,
        component: EventList,
        displayForAdmin: [actions.eventActions.getEvents]
      }, {
        path: '/notifications',
        label: 'Notifications',
        iconName: 'bell',
        exact: false,
        component: NotificationList,
        displayForAdmin: [actions.notificationsActions.getAppNotifications, actions.notificationsActions.getEmailNotifications]
      },
      {
        path: '/roles-and-permissions',
        label: 'Permissions',
        iconName: 'shieldLock',
        exact: false,
        component: RoleAndPermissionList,
        displayForAdmin: [actions.roleAndPermissionAction.getPermissions]
      },
      {
        path: '/shapegroups',
        label: 'Shape Groups',
        iconName: 'shapes',
        exact: false,
        component: ShapeGroupList,
        displayForAdmin: [actions.shapeGroupActions.getShapeGroupsList]
      },
      {
        path: '/logs',
        label: 'Logs',
        iconName: 'logList',
        exact: false,
        component: LogView,
        displayFor: [actions.auditActions.getLogs]
      },
      {
        path: '/settings',
        label: 'Settings',
        iconName: 'settings',
        exact: false,
        component: Settings,
        displayForAdmin: [actions.settingsActions.getSettings]
      }
    ],
    account: [
      {
        path: '/organizations/me',
        label: 'Organization',
        iconName: 'organizations',
        exact: false,
        component: OrganizationDetails,
        displayFor: [actions.organizationActions.getOrganizationById]
      },
      {
        path: '/users/me',
        label: 'Profile',
        iconName: 'profile',
        exact: false,
        component: UserDetails,
        displayFor: [actions.userActions.getUsersList]
      }
    ]
  }
}

export default routes
